import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../../less/IdStyles";
import { selectShopInterstitialOffers } from "../../../selectors/selectShopInfo";
import { utilButton } from "../../../utils/utilButton";
import { actionGameTrackingShopOpenSource } from "../../game-tracking/shop/actionGameTrackingShop";
import { IdShopOpenSource } from "../../game-tracking/shop/IdShopOpenSource";
import { actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { Icon } from "../icon/Icon";
import { IdIcon } from "../icon/IdIcon";
var _HudButtonOffers = function (_a) {
    var onClick = _a.onClick, offer = _a.offer, onShopOpen = _a.onShopOpen;
    if (!offer) {
        return React.createElement(React.Fragment, null);
    }
    var onClickLauncher = function () {
        onShopOpen();
        onClick();
    };
    return (React.createElement("div", { className: IdStyles.OfferBadge + " hud-button__offers", onClick: function () { return utilButton.onClickWithSound(onClickLauncher); } },
        React.createElement(Icon, { icon: IdIcon.ExclusiveWebOfferIcn, styleId: IdStyles.IconExtraLarge })));
};
var mapState = function (state) { return ({
    offer: selectShopInterstitialOffers(state)[0],
}); };
var mapDispatch = function (dispatch) { return ({
    onClick: function () { return dispatch(actionModalOpen(IdModal.Shop)); },
    onShopOpen: function () { return dispatch(actionGameTrackingShopOpenSource(IdShopOpenSource.HUD_OFFER)); },
}); };
export var HudButtonOffers = connect(mapState, mapDispatch)(_HudButtonOffers);



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/hud-button-offers/HudButtonOffers.tsx
// module id = 2298
// module chunks = 3